import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import UserDataService from "../../services/UserService";
import DeviceUsersService from "../../services/DeviceUsersService";
import axios from "axios";
import { Snackbar } from "@mui/material";
import Alert from "@material-ui/lab/Alert";
import { API_URL } from "../../utils/setApiUrl";
// import EditModalForm from './EditFiles/EditModal'

const UsersTable = () => {
  const [users, setUser] = useState([]);
  const [usersPin, setUserPin] = useState([]);

  useEffect(() => {
    retrieveUsers();
  }, []);

  const [loc] = React.useState(() => {
    const locData = JSON.parse(localStorage.getItem("loc"));
    if (locData.id !== undefined) {
      return locData.id;
    }
    return locData;
  });

  const retrieveUsers = async () => {
    try {
      const response = await UserDataService.adminAll();
      let allUsers = response.data;

      // For non-admin users, filter by assigned locations
      if (loc !== "all") {
        const locIds = (Array.isArray(loc) ? loc : [loc]).map(Number);
        allUsers = allUsers.filter(
          (user) => locIds.includes(Number(user.loc_number))
        );
      }

      setUser(allUsers);
    } catch (e) {
      console.log(e);
    }
  };

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  // Snackbars Start
  const [snackbars, setSnackbars] = useState([]);

  const handleCloseSnackbar = (id) => {
    setSnackbars((prevSnackbars) =>
      prevSnackbars.filter((snackbar) => snackbar.id !== id)
    );
  };

  const handleShowSnackbar = (message, severity) => {
    const id = new Date().getTime(); // Unique ID for each snackbar
    const newSnackbar = {
      id,
      message,
      severity,
      position: snackbars.length * 55,
    };

    setSnackbars((prevSnackbars) => [...prevSnackbars, newSnackbar]);
  };
  //Snackbars End

  const client = axios.create({
    baseURL: API_URL,
  });

  const handleUserRemove = (removeUser, resolve) => {
    client
      .post(`/removeUserEverywhere`, {
        user: JSON.stringify(removeUser.sap),
      })
      .then((response) => {
        if (response.status === 200) {
          DeviceUsersService.remove(removeUser.sap).then((response) => {
            if (response.status === 200) {
              handleShowSnackbar(
                `Успешно премахнахте потребителя от всички устройства!`,
                "success"
              );
            } else {
              handleShowSnackbar(
                `Потребителя не беше премахнат от всички устройства, моля опитайте отново!`,
                "error"
              );
            }
          });
          UserDataService.remove(removeUser.sap)
            .then((res) => {
              const dataRemove = [...users];
              const index = removeUser.tableData.id;
              dataRemove.splice(index, 1);
              setUser([...dataRemove]);
              resolve();
              retrieveUsers();
              if (res.status === 200) {
                handleShowSnackbar(
                  `Потребителя е успешно преместен в таблица Изключени Потребители!`,
                  "success"
                );
              } else {
                handleShowSnackbar(
                  `Потребителя не беше преместен в таблица Изключени Потребители. Моля опитайте отново!`,
                  "error"
                );
              }
            })
            .catch((error) => {
              setErrorMessages(["Delete user failed! Server error"]);
              setIserror(true);
            });
        } else {
          handleShowSnackbar(
            `Възникна грешка. Моля, опитайте отново!`,
            "error"
          );
        }
      });
  };

  //! Edit User Event Start
  const [submitted, setSubmitted] = useState(false);

  const handleUserUpdate = (newUserData, resolve) => {
    UserDataService.update(newUserData.sap, newUserData)
      .then((response) => {
        setSubmitted(true);
        console.log(response.data);
        resolve();
        retrieveUsers();
      })
      .catch((e) => {
        setErrorMessages(["Cannot load user data"]);
        setIserror(true);
      });
  };

  const updateUser = () => {
    setSubmitted(false);
  };
  //! Edit User Event Stop

  return (
    <div>
      {snackbars
        .slice()
        .reverse()
        .map((snackbar, index) => (
          <Snackbar
            key={snackbar.id}
            open={true}
            autoHideDuration={5000}
            onClose={() => handleCloseSnackbar(snackbar.id)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            style={{ bottom: `${10 + index * 55}px` }}
          >
            <Alert
              elevation={6}
              variant="filled"
              severity={snackbar.severity}
              onClose={() => handleCloseSnackbar(snackbar.id)}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        ))}
      <MaterialTable
        title="Потребители "
        columns={[
          { title: "Id", field: "id", hidden: true },
          { title: "Име", field: "name" },
          { title: "Имейл", field: "email" },
          { title: "Стая", field: "room_name" },
          {
            title: "Начална Дата",
            field: "start_date",
            type: "datetime",
            dateSetting: { locale: "en-GB", hour12: false },
          },
          {
            title: "Крайна Дата",
            field: "end_date",
            type: "datetime",
            dateSetting: { locale: "en-GB", hour12: false },
          },
          { title: "Локация", field: "loc_name" },
          { title: "Вид потребител", field: "sub_loc_name" },
          { title: "Карта", field: "card" },
        ]}
        data={users}
        style={{
          borderRadius: "0",
          boxShadow: "none",
        }}
        actions={[
          {
            icon: "refresh",
            tooltip: "Refresh",
            isFreeAction: true,
            onClick: retrieveUsers,
          },
        ]}
        options={{
          loadingType: "linear",
          pageSize: 10,
          maxBodyHeight: "65vh",
          showTitle: true,
          sorting: true,
          actionsColumnIndex: -1,
          exportButton: { csv: true, pdf: false },
          filtering: true,
          pageSizeOptions: [5, 10, 20, 50, 100],
        }}
        editable={{
          onRowUpdate: (newUserData) =>
            new Promise((resolve) => {
              handleUserUpdate(newUserData, resolve);
              retrieveUsers();
            }),
          onRowDelete: (removeUser) =>
            new Promise((resolve) => {
              handleUserRemove(removeUser, resolve);
              retrieveUsers();
            }),
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} of {count}",
          },
          header: {
            actions: "Actions",
          },
          body: {
            emptyDataSourceMessage: "Няма данни...",
            filterRow: {
              filterTooltip: "Filter",
            },
            editRow: {
              deleteText: "Сигурни ли сте че искате да изтриете потребителя??",
            },
          },
        }}
      />
    </div>
  );
};

export default UsersTable;
